import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import LecturesTable from "./components/LecturesTable";
import { DayInterface } from "./interfacesAndTypes";
import axios, { AxiosResponse } from "axios";
import { makeStyles } from "@material-ui/core/styles";

const switchObjectToArray = (obj: any) => {
  const result: any[] = [];
  Object.keys(obj).map(function (key, index) {
    result.push(obj[key]);
  });
  return result;
};

const useStyles = makeStyles({
  root: {
    backgroundImage: "url('nephro-logo1.png')",
    backgroundRepeat: "repeat",
  },
});

function App() {
  const [data, setData] = useState<DayInterface[]>([]);
  const classes = useStyles();
  useEffect(() => {
    axios
      .get("/api/main/gettimetable")
      /*  .get("/others/gettimetable2") */
      .then((res: AxiosResponse<any>) => {
        let result: DayInterface[] = [];
        result = switchObjectToArray(res.data);
        for (let i = 0; i < result.length; i++) {
          result[i].lectures = switchObjectToArray(result[i].lectures);
        }
        console.log("!");
        for (let i = 0; i < result.length; i++) {
          for (let j = 0; j < result[i].lectures.length; j++) {
            result[i].lectures[j].links = switchObjectToArray(
              result[i].lectures[j].links
            );
          }
        }
        setData(result);
      })
      .catch((err) => {
        console.log(err);
        setData([]);
      });
  }, []);
  return (
    <div className={classes.root}>
      <Header />
      <LecturesTable days={data} />
    </div>
  );
}

export default App;
